import SignupPopupMain from './Main';
import SignupPopupSuccess from './Success';
import { useGlobal } from '@/utils/useGlobal';

export default function SignupPopup() {
    const { useState, useLang, useRouter, Link, isMobile } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('smssubscribe');
    // 1: popup 留邮箱 2 popup 成功success
    const [statu, setStatu] = useState(1);
    const [optInEmail, setOptInEmail] = useState(false);

    return (
        <div className="signup-popup">
            <SignupPopupMain changeStatu={setStatu} setOptInEmail={setOptInEmail} isMobile={isMobile} />
            {statu === 2 && <SignupPopupSuccess changeStatu={setStatu} t={t} isMobile={isMobile} locale={locale} Link={Link} optInEmail={optInEmail} />}
        </div>
    );
}
